<template>
  <vue-modal id="teamModal"
             classes="vue-modal-container"
             height="auto"
             name="team-modal"
             scrollable
             width="80%">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('team-modal')">
        <i class="close icon"/>
      </button>
    </div>
    <div class="content team-modal-content"
         v-html="trans.content">
      <div></div>

    </div>
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: ['isMobileDevice'],
  computed: {
    ...mapState({
      trans: state => state.trans.teamModal,
    }),
  },
}
</script>

<style>
.team-modal-content p {
  text-align: justify;
}

.team-modal-content span img {
  width: 20px;
}

.team-modal-content h1 {
  display: inline-block;
}

.team-modal-content .team-member {
  text-align: center;
  margin-bottom: 1rem;
  /*height: 260px;*/
  /*overflow: hidden;*/
}

.team-modal-content .team-member > img {
  height: 300px;
}

.team-modal-content .foglaljpalyat-right-logo {
  float: right;
}

.team-modal-content .team-name {
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 1rem;

}

.team-modal-content .team-name > span {
  color: rgb(255, 156, 0)
}
</style>
